export function formatMatch(value) {
  return value === true ? 'Match' : 'Ignore';
}
